import {
  cardStyle,
  getSettingsSections,
  SettingsLink,
} from './SettingsUtilities'
import { Flex, Grid, GridItem, Link, SimpleGrid, Text } from '@ritualco/jutsu'
import { FullWidthPage } from 'components/PageTemplates'
import { useStore } from 'state/store'

import { useContent } from 'lib/content/react'

const PropertyManagerSettings = () => {
  const workspaceId = useStore(state => state.workspace.id) as string
  const contentfulId = 'pmportal.settings.settingsCardContentForPM'

  const { formatMessage } = useContent()

  const settingsLinks = {
    team: (text: string) => (
      <SettingsLink to={`/workspaces/${workspaceId}/settings/team`}>
        {text}
      </SettingsLink>
    ),
    history: (text: string) => (
      <SettingsLink to={`/workspaces/${workspaceId}/settings/history`}>
        {text}
      </SettingsLink>
    ),
    contact: (text: string) => (
      <SettingsLink to={`/workspaces/${workspaceId}/settings/help`}>
        {text}
      </SettingsLink>
    ),
    faq: (text: string) => (
      <Link href="https://ritual.co/faq" py="1" fontSize="small" isExternal>
        {text}
      </Link>
    ),
    profile: (text: string) => (
      <SettingsLink to={`/workspaces/${workspaceId}/settings/profile`}>
        {text}
      </SettingsLink>
    ),
    p: (text: string) => (
      <Text py="1" fontSize="xsmall" color="grayscale.tertiary">
        {text}
      </Text>
    ),
    billing: (text: string) => (
      <SettingsLink to={`/workspaces/${workspaceId}/settings/billing`}>
        {text}
      </SettingsLink>
    ),
  }

  return (
    <FullWidthPage heading="Settings">
      <SimpleGrid columns={[1, 2]} spacing={6}>
        {getSettingsSections(contentfulId).map(card => (
          <Grid
            key={card.title}
            templateColumns="auto 1fr"
            templateRows="auto 1fr"
            columnGap={6}
            rowGap={4}
            sx={cardStyle}
          >
            <GridItem rowSpan={2}>{card.icon}</GridItem>
            <GridItem>
              <Text fontWeight="medium" mb={1}>
                {formatMessage({ id: card.title })}
              </Text>
              <Text color="grayscale.secondary" fontSize="small">
                {formatMessage({ id: card.description })}
              </Text>
            </GridItem>
            <GridItem as={Flex} direction="column">
              {formatMessage({ id: card.content }, settingsLinks)}
            </GridItem>
          </Grid>
        ))}
      </SimpleGrid>
    </FullWidthPage>
  )
}

export default PropertyManagerSettings
